// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ranked bar chart - a standalone map decoration, not a legend (see
   src/core/decoration/ranked-bar-chart.js). Its classes are named accordingly (em-ranked-bar-chart-*),
   deliberately distinct from em-legend-* so consumer stylesheets that target legends don't
   accidentally also restyle this element - notably its per-bar value label, whose fill is computed
   per item for contrast against that bar's own color and must not be overridden by a blanket rule. */

.em-ranked-bar-chart-background {
    fill: white;
    opacity: 0.9;
    rx: 0;
    ry: 0;
    /* Overridden inline (pointer-events) once opacity is set: fully opaque (1) means no map is
       visible behind the box, so it blocks pointer events reaching the map underneath instead of
       letting them pass through to a hidden tooltip. See updateBackgroundBoxOpacity(). */
    pointer-events: none;
    filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.5));
}

/* titles */
.em-ranked-bar-chart-title {
    font-weight: bold;
    font-size: 15px;
    fill: #4c4b4b;
}

.em-ranked-bar-chart-subtitle {
    font-size: 15px;
    fill: #696969;
    opacity: 0.8;
}

/* labels */
.em-ranked-bar-chart-label {
    font-size: 14px;
    stroke: none;
    fill: #5e5e5e;
    dominant-baseline: unset;
}

.em-ranked-bar-chart-code {
    font-style: italic;
    font-weight: bold;
}

/* cursor: pointer */
.em-ranked-bar-chart-rect,
.em-ranked-bar-chart-histogram-bar {
    cursor: pointer;
}

/* hover */
.em-ranked-bar-chart-rect:hover {
    stroke-width: 2;
    stroke: red;
}
`, "",{"version":3,"sources":["webpack://./src/css/decoration/ranked-bar-chart.css"],"names":[],"mappings":"AAAA;;;;qGAIqG;;AAErG;IACI,WAAW;IACX,YAAY;IACZ,KAAK;IACL,KAAK;IACL;;yFAEqF;IACrF,oBAAoB;IACpB,mDAAmD;AACvD;;AAEA,WAAW;AACX;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,oBAAoB;AACpB;;IAEI,eAAe;AACnB;;AAEA,UAAU;AACV;IACI,eAAe;IACf,WAAW;AACf","sourcesContent":["/* Ranked bar chart - a standalone map decoration, not a legend (see\n   src/core/decoration/ranked-bar-chart.js). Its classes are named accordingly (em-ranked-bar-chart-*),\n   deliberately distinct from em-legend-* so consumer stylesheets that target legends don't\n   accidentally also restyle this element - notably its per-bar value label, whose fill is computed\n   per item for contrast against that bar's own color and must not be overridden by a blanket rule. */\n\n.em-ranked-bar-chart-background {\n    fill: white;\n    opacity: 0.9;\n    rx: 0;\n    ry: 0;\n    /* Overridden inline (pointer-events) once opacity is set: fully opaque (1) means no map is\n       visible behind the box, so it blocks pointer events reaching the map underneath instead of\n       letting them pass through to a hidden tooltip. See updateBackgroundBoxOpacity(). */\n    pointer-events: none;\n    filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.5));\n}\n\n/* titles */\n.em-ranked-bar-chart-title {\n    font-weight: bold;\n    font-size: 15px;\n    fill: #4c4b4b;\n}\n\n.em-ranked-bar-chart-subtitle {\n    font-size: 15px;\n    fill: #696969;\n    opacity: 0.8;\n}\n\n/* labels */\n.em-ranked-bar-chart-label {\n    font-size: 14px;\n    stroke: none;\n    fill: #5e5e5e;\n    dominant-baseline: unset;\n}\n\n.em-ranked-bar-chart-code {\n    font-style: italic;\n    font-weight: bold;\n}\n\n/* cursor: pointer */\n.em-ranked-bar-chart-rect,\n.em-ranked-bar-chart-histogram-bar {\n    cursor: pointer;\n}\n\n/* hover */\n.em-ranked-bar-chart-rect:hover {\n    stroke-width: 2;\n    stroke: red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
